module.exports = __webpack_public_path__ + "static/media/protegedatos_2.32ead33b.jpg";